// extracted by mini-css-extract-plugin
export default {"videoPlayer":"playVideo_videoPlayer__DYlLS"};